import { render, staticRenderFns } from "./travelTask.vue?vue&type=template&id=055cd5bf&scoped=true"
import script from "./travelTask.vue?vue&type=script&lang=js"
export * from "./travelTask.vue?vue&type=script&lang=js"
import style0 from "./travelTask.vue?vue&type=style&index=0&id=055cd5bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055cd5bf",
  null
  
)

export default component.exports